<template>

    <container-complex v-if="isDesktop"
                       :showSteps="true"
                       :steps="steps"
                       :stepIndex="step - 1"
                       @previous="stepPrevious"
                       @clickTab="clickTab"
    >

        <!--        BODY-->

        <template v-slot:body>


            <div v-if="isStep1">

                <h1 class="text-xlSemibold" v-show="!isDesktop">{{ $t('enable_imap') }}</h1>

                <phase class="mt__24"
                       :number="1"
                       :title="$t('sign_in_naver')"
                       :subtitle="$t('redirect_new_tab')"
                       :image="isDesktop ? '/img/login/naver/browser.svg' : '/img/login/naver/phone.svg'"/>
                <phase class="mt__8"
                       :number="2"
                       :title="$t('settings_tab')"/>
                <phase class="mt__8"
                       :number="3"
                       :title="$t('select_enable_imap')"/>
                <phase class="mt__8"
                       :number="4"
                       :title="$t('save_return_cleanfox')"/>

            </div>

            <div v-if="isStep2">

                <h1 class="text-xlSemibold" v-show="!isDesktop">{{ $t('2FA') }}</h1>

                <phase :number="1" :title="$t('sign_in_naver_again')" class="mt__24"/>
                <phase :number="2" :title="$t('activate_2FA')" :subtitle="$t('click_enable_follow_naver')" class="mt__8" :preventDefault="true" @clickLink="fALinkClicked"/>
                <phase :number="3" :title="$t('return_to_Cleanfox')" class="mt__8"/>

            </div>

            <div v-if="isStep3">

                <h1 class="text-xlSemibold" v-show="!isDesktop">{{ $t('web_app_password_creation') }}</h1>

                <phase :number="1" :title="$t('naver_link_app_password', 0, {url: 'https://nid.naver.com/user2/help/myInfoV2?m=viewSecurity'})" class="mt__24" :blank="true" @clickLink="appPasswordLinkClicked"/>
                <phase :number="2" :title="$t('generate_ap')" class="mt__8"/>
                <phase :number="3" :title="$t('copy_12_car')" :subtitle="$t('naver_copy_next_step')" class="mt__8"/>

            </div>

            <template v-if="isStep4">

                <h1 class="text-xlSemibold" v-show="!isDesktop">{{ $t('connect_to_cleanfox') }}</h1>

                <markdown class="text-baseRegular mt__24"
                          :color="'#32A3EB'"
                          :text="$tc('enter_app_password', 0, {email})"></markdown>

                <input-label class="mt__24"
                             :placeholder="$t('login_application_password_placeholder')"
                             :value="appPassword"
                             :error="errorPassword"
                             @update="updateAppPassword"
                             @pressEnter="loginAppPassword"/>

            </template>

        </template>


        <!--        FOOTER-->

        <template v-slot:footer>

            <template v-if="isStep1">

                <button class="cta-medium-secondary" @click="ctaStep1">
                    <span v-show="!isImapLinkClicked">{{ $t('open_naver') | capitalizeFirstLetter }}</span>
                    <img v-show="!isImapLinkClicked" src="/img/icons/external-link.svg" class="img__24 ml__8">

                    <span v-show="isImapLinkClicked">{{ $t('imap_enabled') }}</span>
                    <img v-show="isImapLinkClicked" src="/img/icons/arrow-right-white.svg" class="img__24 ml__8">
                </button>

            </template>

            <template v-if="isStep2">

                    <button class="cta-medium-tertiary" @click="stepPrevious">
                        <img src="/img/icons/arrow-left-blue.svg" class="img__24 mr__4">
                        <span class="ml__4">{{ $t('global_previous') }}</span>
                    </button>

                    <div class="spacer-footer"></div>

                    <button class="cta-medium-secondary" @click="ctaStep2">
                        <span v-show="!is2FAClicked">{{ $t('open_naver') | capitalizeFirstLetter }}</span>
                        <img v-show="!is2FAClicked" src="/img/icons/external-link.svg" class="img__24 ml__8">

                        <span v-show="is2FAClicked">{{ $t('global_continue') }}</span>
                        <img v-show="is2FAClicked" src="/img/icons/arrow-right-white.svg" class="img__24 ml__8">
                    </button>

            </template>

            <template v-if="isStep3">

                <button class="cta-medium-tertiary" v-if="!isAppPasswordLinkClicked && !isDesktop"
                        @click="stepPrevious">
                    <img src="/img/icons/arrow-left-blue.svg" class="img__24 mr__4">
                    <span class="ml__4">{{ $t('global_previous') }}</span>
                </button>
                <div class="spacer-footer" v-if="!isDesktop"></div>
                <button class="cta-medium-secondary" @click="ctaStep3" :disabled="!isAppPasswordLinkClicked">
                    <span>{{ $t('web_google_code') }}</span>
                    <img src="/img/icons/arrow-right-white.svg" class="img__24 ml__8">
                </button>

            </template>

            <template v-if="isStep4">

                <button class="cta-medium-primary" :disabled="isCtaAppPasswordDisabled" @click="loginAppPassword">
                    <lottie-loader v-if="loading" :size="24"></lottie-loader>
                    <span v-else>{{ $t('login_imap_manual_form_cta') }}</span>
                </button>

            </template>


        </template>

    </container-complex>
    <block-mobile-popup v-else :provider="provider"></block-mobile-popup>

</template>

<script>

import BlockMobilePopup from '../../components/BlockMobilePopup.vue'
import ContainerComplex from '../../components/loginFlow/ContainerComplex.vue'
import InputLabel from '../../components/inputs/InputLabel.vue'
import LottieLoader from '../../components/lottie/LottieLoader.vue'
import Markdown from '../../components/Markdown.vue'
import Phase from '../../components/loginFlow/google/Phase.vue'

import Login from '../../modules/login'
import UserFlow from '../../modules/userFlow'

export default {
    name: 'naver-login',

    components: {
        BlockMobilePopup,
        ContainerComplex,
        InputLabel,
        LottieLoader,
        Markdown,
        Phase
    },

    props: {
        email: {
            type: String,
            default: ''
        }
    },

    watch: {
        step() {
            this.isImapLinkClicked = false
            this.is2FAClicked = false
            this.isAppPasswordLinkClicked = false
            this.errorPassword = ''
            UserFlow.setPage(this, `web_connexion_flow_step${this.step}`)
        }
    },

    computed: {

        isStep1() {
            return this.step === 1
        },
        isStep2() {
            return this.step === 2
        },
        isStep3() {
            return this.step === 3
        },
        isStep4() {
            return this.step === 4
        },
        isCtaAppPasswordDisabled() {
            return this.appPassword.length !== 12 || this.loading
        }
    },

    data() {
        return {
            step: 0,
            isImapLinkClicked: false,
            is2FAClicked: false,
            isAppPasswordLinkClicked: false,
            provider: 'naver',
            imapPassword: '',
            errorPassword: '',
            appPassword: '',
            loading: false,
            steps: [{
                title: this.$t('enable_imap')
            }, {
                title: this.$t('2FA')
            }, {
                title: this.$t('web_app_password_creation')
            }, {
                title: this.$t('connect_to_cleanfox')
            }]
        }
    },

    mounted() {
        UserFlow.setPage(this, 'web_connexion_flow_naver_login')
        this.stepNext()
    },

    methods: {
        stepNext() {
            if (this.step < 4) {
                this.step++
            }
        },
        stepPrevious() {
            if (this.step > 1) {
                this.step--
            } else {
                this.$router.push({path: '/'})
            }
        },
        ctaStep1() {
            if (this.isImapLinkClicked) {
                this.stepNext()
            } else {
                this.isImapLinkClicked = true
                window.open('https://mail.naver.com/v2/settings/imap', '_blank', 'noopener,noreferrer')
            }
        },
        ctaStep2() {
            if (this.is2FAClicked) {
                this.stepNext()
            } else {
                this.is2FAClicked = true
                window.open('https://nid.naver.com/user2/help/myInfoV2?m=viewSecurity', '_blank', 'noopener,noreferrer')
            }
        },
        ctaStep3() {
            this.stepNext()
        },
        login(password) {
            this.loading = true

            Login.connect({
                vue: this,
                email: this.email,
                password,
                provider: this.provider
            })
                .catch(() => {
                    this.errorPassword = this.$t('incorrect_password')
                    this.loading = false
                })
        },
        loginAppPassword() {
            this.login(this.appPassword)
        },
        updateAppPassword(value) {
            this.appPassword = value
        },
        fALinkClicked() {
            this.is2FAClicked = true
            this.stepNext()
        },
        appPasswordLinkClicked() {
            this.isAppPasswordLinkClicked = true
        },
        clickTab(tabIndex) {
            if(tabIndex < this.step) {
                this.step = tabIndex
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.spacer-footer {
    min-width: 8px;
}
</style>